import * as React from 'react';
import { ITranslations, IConfig } from './utils';
import { ContextValueType, UpdateProviderType, Context } from './Context';

interface IProps {
    translations?: ITranslations | null;
    config?: IConfig | null;
}

export const addContext = <T extends IProps>(initialize?: T) => {
    const defaultValues = initialize || ({ config: null, translations: null } as T);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (WrappedComponent: any): any =>
        class extends React.Component<IProps, ContextValueType<typeof defaultValues>> {
            static displayName = 'AddContext';

            constructor(props: IProps) {
                super(props);

                this.state = {
                    updateProvider: this.updateProvider,
                    ...defaultValues
                };
            }

            updateProvider: UpdateProviderType<T> = (newValues: Partial<T>) => {
                this.setState({
                    ...this.state,
                    ...newValues
                });
            };

            render() {
                return (
                    <Context.Provider value={this.state}>
                        <WrappedComponent {...this.props} />
                    </Context.Provider>
                );
            }
        };
};
